import { Building, Factory, Hotel, MoveRight, University, User, Users } from 'lucide-react';
import { ChangeEvent } from 'react';
import { sourceOptions } from 'utils/constants';
import Button from '../Button';
import { Input } from '../Input';
import Label from '../Label';
import Select from '../Select';

export type CompanyDetailProps = {
    teamSize: string;
    source: string;
    companyName: string;
    setTeamSize: (value: string) => void;
    setSource: (value: string) => void;
    handleChangeCompanyName: (event: ChangeEvent<HTMLInputElement>) => void;
    handleStartTrial: () => void;
    isTrialPending: boolean;
}

const teamSizeOptions = [
    { value: '1', label: 'Just me ', icon: <User size='16px' /> },
    { value: '10', label: '2-10', icon: <Users size='16px' /> },
    { value: '50', label: '11-50', icon: <University size='16px' /> },
    { value: '100', label: '51-100', icon: <Hotel size='16px' /> },
    { value: '500', label: '101-500', icon: <Building size='16px' /> },
    { value: '1000', label: '500+', icon: <Factory size='16px' /> },
];

const SignupCompanyDetails = ({
    teamSize,
    source,
    companyName,
    setTeamSize,
    setSource,
    handleChangeCompanyName,
    handleStartTrial,
    isTrialPending
}: CompanyDetailProps) => {
    return (
        <>
            <div id="atarim-signup" className="mt-4 flex flex-col gap-6">
                <div className="flex flex-col gap-2">
                    <Label className="flex items-center">Workspace Name</Label>
                    <Input
                        value={companyName}
                        placeholder="What's your company or brand name *"
                        onChange={handleChangeCompanyName}
                    />
                    <Label className="mt-4 flex items-center">
                        Team Size
                    </Label>
                    <Select value={teamSize} onValueChange={setTeamSize}>
                        <Select.Trigger className="w-full text-gray-400">
                            <Select.Value placeholder="How Big Is Your Team?" />
                        </Select.Trigger>
                        <Select.Content>
                            {teamSizeOptions.map((size) => (
                                <Select.Item value={size.value.toString()} key={size.value}>
                                    <div className='flex items-center gap-2 text-textcolor'> {size.icon}{size.label}</div>

                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select>
                    {/* How you heard about Atarim */}
                    <Label className="mt-4 flex items-center">
                        How did you hear about us:
                    </Label>
                    <Select value={source} onValueChange={setSource}>
                        <Select.Trigger className="w-full text-gray-400">
                            <Select.Value placeholder="How Did You Discover Us?" />
                        </Select.Trigger>
                        <Select.Content>
                            {sourceOptions.map((src) => (
                                <Select.Item value={src.value.toString()} key={src.value}>
                                    <div className="text-textcolor">{src.name}</div>
                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select>
                </div>
                <div className="mt-4 flex flex-col">
                    <Button
                        onClick={handleStartTrial}
                        disabled={companyName.length === 0}
                        size="md"
                        className="mb-4 text-sm"
                        loading={isTrialPending}
                        rightIcon={<MoveRight size={18} />}
                    >
                        Start Collaborating
                    </Button>
                </div>
            </div>
        </>
    );
};

export default SignupCompanyDetails;
